import { FC, RefAttributes, useCallback, useRef, useState } from "react"
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip, { TooltipProps } from "react-bootstrap/esm/Tooltip";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";


const PlanNameTitle: FC = (): JSX.Element => {
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  const handleIconClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    changeInfoIconIndex(infoIconIndex !== 4 ? 4 : -1);
  };

   const tooltipOverlay = useCallback(
        (props: JSX.IntrinsicAttributes & TooltipProps & RefAttributes<HTMLDivElement>) => (
            <Tooltip {...props} className={`${props.className || ""} custom-insurance-tooltip`}>
                <p>
                   This list shows the options associated with the insurance name you selected. If you do not find your plan name in these options, this is a free text field. Please type the plan name and click out of the field, and the name you typed will be saved.
                </p>
            </Tooltip>
        ),
        []
    );

    return (
        <span>
            <OverlayTrigger 
                trigger={["click", "hover"]}
                overlay={tooltipOverlay}
                placement="auto"                   
            >
                <i className="bi bi-question-circle-fill ms-2"></i>    
            </OverlayTrigger>
        </span>
    );
}

export default PlanNameTitle
